export const OtherDataContactsActionTypes = {
  API_RESPONSE_SUCCESS: '@@other-data-contacts/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@other-data-contacts/API_RESPONSE_ERROR',

  GET_OTHER_DATA_CONTACTS: '@@other-data-contacts/GET_OTHER_DATA_CONTACTS',
  LIST_OTHER_DATA_CONTACTS: '@@other-data-contacts/LIST_OTHER_DATA_CONTACTS',
  ADD_OTHER_DATA_CONTACTS: '@@other-data-contacts/ADD_OTHER_DATA_CONTACTS',
  UPDATE_OTHER_DATA_CONTACTS: '@@other-data-contacts/UPDATE_OTHER_DATA_CONTACTS',
  DELETE_OTHER_DATA_CONTACTS: '@@other-data-contacts/DELETE_OTHER_DATA_CONTACTS',

  RESET: '@@other-data-contacts/RESET'
}
